import PhoneInput from "src/components/PhoneInput";
import React, { useContext, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { userContext } from "src/context/UserContext";
import { url } from "src/helpers";
import ReCAPTCHA from "react-google-recaptcha";
import Footer from "src/components/Footer";
import NewHeader from "src/New Codes/components/NewHeader";

function Signup() {
  const { setLoad } = useContext(userContext);
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [mobile, setMobile] = useState("");
  const [role, setRole] = useState("1");
  const [selfDriver, setSelfDriver] = useState(false);
  const [business, setBusiness] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [captcha, setCaptcha] = useState(false);
  const [termCondition, setTermCondition] = useState(false);

  const history = useHistory();

  const verifyCaptcha = () => setTermCondition(true);
  const acceptTermsCondition = (e) => setCaptcha(e.target.checked);

  function submitLogin(e) {
    e.preventDefault();

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    async function send() {
      setLoad(true);
      let data = {
        first_name: fname, last_name: lname, email,
        phone_number: mobile, business_name: business, user_type: role, password,
        is_self_driver: role === "2" && selfDriver,
      };
      
      try {
        const response = await fetch(url + "register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });
        const resData = await response.json();
        setLoad(false);
        if (resData.status === 200) {
          toast.success(resData.message);
          history.push("/login");
        } else {
          toast.error(resData.message);
        }
      } catch (err) {
        setLoad(false);
        toast.error("Oops! Something went wrong.");
      }
    }
    send();
  }

  return (
    <>
    <NewHeader />
    <div className="custom_signup_new split_layout">
      {/* Left Side: Logistics Hero Section */}
      <div className="signup-hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="brand-logo mb-4">
             <i className="fa fa-truck-moving hero-logo-icon"></i>
          </div>
          <h1 className="hero-title">Welcome to <br /><span>Beba Mzigo</span></h1>
          <p className="hero-description">
            Your trusted partner for efficient logistics and transportation solutions. 
            Join our network to streamline your shipments, manage your fleet, and 
            grow your business with cutting-edge technology.
          </p>
          <div className="hero-features">
            <div className="feature-item"><i className="fa fa-check-circle"></i> Real-time Tracking</div>
            <div className="feature-item"><i className="fa fa-check-circle"></i> Verified Transporters</div>
            <div className="feature-item"><i className="fa fa-check-circle"></i> Secure Payments</div>
          </div>
        </div>
      </div>

      {/* Right Side: Form Section */}
      <div className="signup-form-section">
        <div className="form-inner-container">
          <div className="form-header mb-4">
            <h2>Create Account</h2>
            <p>Enter your details to get started</p>
          </div>

          <form onSubmit={submitLogin}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="custom-label">First Name</label>
                <div className="input-group-custom">
                  <span className="input-icon"><i className="fa fa-user"></i></span>
                  <input required type="text" className="custom-input with-icon" placeholder="John" value={fname} onChange={(e) => setFname(e.target.value)} />
                </div>
              </div>
              <div className="col-md-6">
                <label className="custom-label">Last Name</label>
                <div className="input-group-custom">
                  <span className="input-icon"><i className="fa fa-user"></i></span>
                  <input required type="text" className="custom-input with-icon" placeholder="Doe" value={lname} onChange={(e) => setLname(e.target.value)} />
                </div>
              </div>

              <div className="col-md-6">
                <label className="custom-label">Email Address</label>
                <div className="input-group-custom">
                  <span className="input-icon"><i className="fa fa-envelope"></i></span>
                  <input required type="email" className="custom-input with-icon" placeholder="name@company.com" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
              </div>

              <div className="col-md-6">
                <label className="custom-label">User Type</label>
                <select className="custom-input" value={role} onChange={(e) => { setRole(e.target.value); if (e.target.value !== "2") setSelfDriver(false); }}>
                  <option value="1">Shipper</option>
                  <option value="2">Transporter</option>
                </select>
              </div>
              
              <div className="col-md-6">
                <label className="custom-label">Phone Number</label>
                <PhoneInput required onChange={setMobile} />
              </div>

              <div className="col-md-6">
                <label className="custom-label">Business Name</label>
                <input required type="text" className="custom-input" placeholder="Legal Entity Name" value={business} onChange={(e) => setBusiness(e.target.value)} />
              </div>

              <div className="col-md-6">
                <label className="custom-label">Password</label>
                <div className="input-group-custom">
                  <span className="input-icon"><i className="fa fa-lock"></i></span>
                  <input required minLength={6} type={showPassword ? "text" : "password"} className="custom-input with-icon" placeholder="Min. 6 characters" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" />
                  <span className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
                    <i className={showPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                  </span>
                </div>
              </div>

              <div className="col-md-6">
                <label className="custom-label">Confirm Password</label>
                <div className="input-group-custom">
                  <span className="input-icon"><i className="fa fa-lock"></i></span>
                  <input required type={showPassword ? "text" : "password"} className="custom-input with-icon" placeholder="Re-enter password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} autoComplete="new-password" />
                </div>
              </div>

              {role === "2" && (
                <div className="col-12">
                  <label
                    htmlFor="selfDriver"
                    style={{ display: "flex", gap: 12, alignItems: "flex-start", border: "1px solid #e4e8ec", borderRadius: 12, padding: "12px 14px", cursor: "pointer", background: selfDriver ? "#fdf6ee" : "#fff", margin: 0 }}
                  >
                    <input
                      id="selfDriver"
                      type="checkbox"
                      checked={selfDriver}
                      onChange={(e) => setSelfDriver(e.target.checked)}
                      style={{ marginTop: 4 }}
                    />
                    <span>
                      <b style={{ display: "block", fontSize: 15 }}>I also drive my own loads (self-driver)</b>
                      <small className="text-muted" style={{ fontSize: 13 }}>You will appear in your own driver list and can assign shipments to yourself.</small>
                    </span>
                  </label>
                </div>
              )}

            </div>

            <div className="captcha-container my-4">
              <ReCAPTCHA sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" onChange={verifyCaptcha} />
            </div>

            <div className="form-check mb-4">
              <input type="checkbox" className="custom-check" id="agree" onChange={acceptTermsCondition} />
              <label htmlFor="agree" className="ml-2 small text-muted">
                I agree to the <Link to="/terms" className="forgot-link font-weight-bold">Terms & Conditions</Link>
              </label>
            </div>

            <button disabled={!(captcha && termCondition)} type="submit" className="btn-signup-full">
              CREATE ACCOUNT
            </button>
            
            <p className="text-center mt-4 text-muted">
              Already have an account? <Link to="/login" className="forgot-link font-weight-bold">Sign In</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
}

export default Signup;